import { render } from "./pointOrderDetail.vue?vue&type=template&id=8e38ccd8&scoped=true"
import script from "./pointOrderDetail.vue?vue&type=script&lang=js"
export * from "./pointOrderDetail.vue?vue&type=script&lang=js"

import "./pointOrderDetail.vue?vue&type=style&index=0&id=8e38ccd8&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e38ccd8"]])

export default __exports__